export namespace ActiveProductsActions {
    export class ActiveProducts {
        static readonly type = 'ActiveProductsActions.ActiveProducts';
    }
}
